import queryString from 'query-string';

export const getQString = (search) => {
  const parsed = queryString.parse(search);
  let qString = '';
  if (parsed.wineType) {
    qString += `&wineType=${parsed.wineType}`;
  }
  if (parsed.wineVarietal) {
    qString += `&wineVarietal=${parsed.wineVarietal}`;
  }
  if (parsed.wineCountryCode) {
    qString += `&wineCountryCode=${parsed.wineCountryCode}`;
  }
  if (parsed.wineRegion) {
    qString += `&wineRegion=${parsed.wineRegion}`;
  }
  if (parsed.wineAppellation) {
    qString += `&wineAppellation=${parsed.wineAppellation}`;
  }
  if (parsed.vendorId) {
    qString += `&vendorId=${parsed.vendorId}`;
  }
  if (parsed.fromPrice) {
    qString += `&fromPrice=${parsed.fromPrice}`;
  }
  if (parsed.toPrice) {
    qString += `&toPrice=${parsed.toPrice}`;
  }
  if (qString.length === 0) {
    qString = undefined;
  }
  return qString;
};
